import React, { useCallback } from "react";

import { ICellRendererParams } from "@ag-grid-community/core";

import { Activity, Company, Deal, Person } from "@mapmycustomers/shared/types/entity";

import EntityChip from "@app/component/EntityChip";
import { ActivityFieldName } from "@app/util/fieldModel/ActivityFieldModel";

const RelationshipCellRenderer: React.FC<ICellRendererParams> = ({ colDef, context, node }) => {
  const entity = node.data as Activity;
  let value: Company | Deal | Person | undefined;
  if (colDef.colId === ActivityFieldName.COMPANY) {
    value = entity.account;
  } else if (colDef.colId === ActivityFieldName.PERSON) {
    value = entity.contact;
  } else if (colDef.colId === ActivityFieldName.DEAL) {
    value = entity.deal;
  }

  const handleClick = useCallback(() => {
    context.onRelationshipView?.(value);
  }, [context, value]);

  if (!value) {
    // Wrapping into fragment because this component can't return a plain string.
    // On the other hand it can't return `null` because that's an AgGrid recommendation
    // to return empty strings: https://www.ag-grid.com/react-hooks/#react-null
    return <>{""}</>;
  }

  return (
    <div>
      <EntityChip
        entityId={value.id}
        entityType={value.entity}
        name={value.name}
        onClick={handleClick}
        suppressTooltip
      />
    </div>
  );
};

export default RelationshipCellRenderer;
